export default __webpack_public_path__ + "b4bd5cddeb6ea6844ef0fba428c9c5a5.png";